/**
 * @generated SignedSource<<e59f5e79a9bb25cbf87e83d18f76af88>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type CardBrand = "AMERICAN_EXPRESS" | "CHINA_UNIONPAY" | "DISCOVER" | "DISCOVER_DINERS" | "EBT" | "EFTPOS" | "FELICA" | "INTERAC" | "JCB" | "MASTERCARD" | "OTHER_BRAND" | "SQUARE_CAPITAL_CARD" | "SQUARE_GIFT_CARD" | "UNKNOWN" | "VISA";
import { FragmentRefs } from "relay-runtime";
export type PaymentMethod_squareCardOnFile$data = {
  readonly cardBrand: CardBrand;
  readonly expMonth: number;
  readonly expYear: number;
  readonly id: string;
  readonly lastFour: string;
  readonly " $fragmentType": "PaymentMethod_squareCardOnFile";
};
export type PaymentMethod_squareCardOnFile$key = {
  readonly " $data"?: PaymentMethod_squareCardOnFile$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentMethod_squareCardOnFile">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentMethod_squareCardOnFile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "expMonth",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "expYear",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cardBrand",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastFour",
      "storageKey": null
    }
  ],
  "type": "SquareCardOnFile",
  "abstractKey": null
};

(node as any).hash = "ea3039f2e37feb119cee0c5581f13fd1";

export default node;
